import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import { resetState, goToPage, setDisconnectTypeOfService, setServiceToDisconnect } from '../../../DisconnectServiceSlice'
import { Container, Row, Col } from 'reactstrap';
import Asmahta from '../../DisconnectCommonParts/summaryNumberProvider'
import './SuccessfulDisconnect'
import gaParams from '../../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../../utilities/analytics/tracking';
import { clearStateHistoryAction } from '../../../../../../utilities/stateHistory/stateHistorySlice';
import { isBrowser, isMobile } from "react-device-detect";

function SuccessfulDisconnect(props) {

    const asmahtaNumber = Asmahta();
    const disconnectMsg = "ותוך כמה דקות השירות יעלם גם מהאזור האישי ומהרשימה שלך "

    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_SUMMARY_CONCLUDE_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_SUMMARY_CONCLUDE_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_SUMMARY_CONCLUDE_PAGE_CELLULAR.eventParams);
      }, [])

    async function goBackHome() {
        props.clearStateHistoryAction();
        var content = await props.context.loadContentByPath(props.redirectTo);
        props.context.navigateTo(content);
    }

    return (
        <Container className="SuccessfulDisconnect-root">
            <Row className="header-row">
                <h3 className="header">סיכום פרטי הניתוק</h3>
                {props.dateChanged === false ? <span className="announcement">הניתוק הושלם, תודה שהיית איתנו <br /> {disconnectMsg}</span> : <span className="announcement">הניתוק הושלם, תודה שהיית איתנו</span>}
            </Row>
            <Row className="user-summary-number-row">
                <Col>
                    <div className="detail"><span className="txt">מספר אסמכתא: </span>{asmahtaNumber}</div>
                </Col>
            </Row>
            {isBrowser ? 
            <Row className="user-details-row">
                <Col>
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
                <Col>
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col>
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
            </Row>
            :
            <>
            <Row className="user-details-row">
                <Col className="pl-1 pr-1">
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
                
            </Row>
            <Row className="user-details-row-second">
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
            </Row>
            </>
            }
            <Row className="summary-row">
                <div className="summary">
                <div style={{fontSize: '0.938rem'}}><strong>{props.serviceToDisconnect.title} {props.serviceToDisconnect.subscriberNumber}</strong></div>
                    <div style={{fontSize: '0.813rem'}}>{props.serviceToDisconnect.email}</div>
                    <div style={{fontSize: '0.813rem'}}>{props.serviceToDisconnect.clientId}</div>
                    <div style={{fontSize: '0.813rem'}}>{props.serviceToDisconnect.address}</div>
                    <br />
                    <div style={{fontSize: '0.938rem'}} className="summary-date"><strong>הניתוק ייכנס לתוקף</strong></div>
                    <div style={{fontSize: '0.813rem'}}>{props.summarizeUserDisconnectDetails.timeDisconnectScheduled}</div>
                </div>
            </Row>
            <div className="msg-div">
                {props.finalDisconnectResponse === true && props.emailInStore.valid === true && props.emailInStore.email !== "" ? 
                    <div className="mail-msg">נשלח את הפרטים למייל שהזנת</div> : null
                }
            </div>
            <BtnSubmit text="סיום" onclick={() => goBackHome()}/>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    summarizeUserDisconnectDetails: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    UserInfo: state.authentication.loginData.userDetails,
    emailInStore: state.disconnectServicesBlock.summarizeUserDisconnectDetails.emailForm,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    dateChanged: state.disconnectServicesBlock.changedDateOfDisconnect
});
  
const mapDispatchToProps = {
    goToPage,
    setDisconnectTypeOfService,
    setServiceToDisconnect,
    resetState,
    clearStateHistoryAction
};
  
export default connect(mapStateToProps, mapDispatchToProps)(SuccessfulDisconnect);